export default "__VITE_ASSET__DDOYH_08__"